
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 2.29c-3.446 0-6.25 2.931-6.25 6.536 0 3.604 2.804 6.537 6.25 6.537s6.25-2.933 6.25-6.537c0-3.605-2.804-6.537-6.25-6.537zm0 11.765c-2.757 0-5-2.346-5-5.23 0-2.883 2.243-5.229 5-5.229s5 2.346 5 5.23c0 2.883-2.243 5.23-5 5.23z","fill":"#E27CFC"}}),_c('path',{attrs:{"d":"M8.125 5.557h-1.25V9.48h3.75V8.172h-2.5V5.557z","fill":"#E27CFC"}})])
          )
        }
      }
    